import React from "react";
import Header from "../Header/Header";
import Bodies from "../Body/Bodies/Bodies";
import { useLayoutEffect } from "react";

function Technical() {
    
  return (
    <div>
      <Header />
      <Bodies />
    </div>
  );
}

export default Technical;
